import React from 'react';
import { useTranslation } from 'react-i18next';
import { nanoid } from 'nanoid';
import DOMPurify from 'dompurify';

import { convertKeysToCamelCase } from '../helpers/baseHelper';
import useGeneral from '../hooks/useGeneral';
import { lessonsPageByTypeAndVideoId } from '../helpers/redirectHelper';
import style from '../assets/scss/components/VideoCourseDescription.module.scss';

function VideoCourseDescription(props) {
  const { t } = useTranslation();
  const { longDescription, description, coursePlan, type, eLearning } = props;
  const { handleRedirect } = useGeneral();
  const {
    wrapper,
    courseTitle,
    courseWrapper,
    planModule,
    planTitle,
    planText,
    courseDescription,
  } = convertKeysToCamelCase(style);

  return (
    <div className={wrapper}>
      <div
        className={courseDescription}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(longDescription || description) }}
      />
      {coursePlan && (
        <div>
          <h3 className={courseTitle}>
            {eLearning
              ? t('video.details.page.tabs.eLearningOverview.eLearningPlan')
              : t('video.details.page.tabs.courseOverview.coursePlan')}
          </h3>
          <div className={courseWrapper}>
            {coursePlan.map((plan, index) => {
              const { quizzesCount, title, videosCount, lessonTime } = plan;
              const [hours, minutes] = lessonTime.split(':');

              return (
                <div key={nanoid()}>
                  <p className={planModule}>
                    {t(`video.details.page.tabs.courseOverview.coursePlan.${type}.module`, { id: index + 1 })}
                  </p>
                  <p
                    className={planTitle}
                    onClick={
                      plan.videoToPlay
                        ? () => handleRedirect(lessonsPageByTypeAndVideoId(type, plan.videoToPlay.id))
                        : undefined
                    }
                    style={plan.videoToPlay ? { cursor: 'pointer' } : undefined}
                  >
                    {title}
                  </p>
                  <p className={planText}>
                    {videosCount > 1
                      ? t(`video.details.page.tabs.courseOverview.coursePlan.${type}.lessons.plural`, {
                          count: videosCount,
                          time: `${hours}h ${minutes}m`,
                        })
                      : t(`video.details.page.tabs.courseOverview.coursePlan.${type}.lessons`, {
                          count: videosCount,
                          time: `${hours}h ${minutes}m`,
                        })}
                  </p>
                  {type !== 'clips' && type !== 'typer' && !eLearning ? (
                    <p className={planText}>
                      {t('video.details.page.tabs.courseOverview.coursePlan.quiz', { count: quizzesCount })}
                    </p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoCourseDescription;
